import { Button, Password, Text } from '@104ha/base-ui';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { useLogin } from '../hook/use-auth';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	/* margin-top: 20vh; */
	height: 100%;

	.-panel {
		width: 420px;
		border: 1px solid #ccc;
		border-radius: 6px;
		background-color: #fff;
		padding: 30px;
		box-shadow: 0 0 0 1px rgb(53 72 91 / 10%), 0 2px 2px rgb(0 0 0 / 3%), 0 4px 4px rgb(0 0 0 / 4%),
			0 10px 8px rgb(0 0 0 / 5%), 0 15px 15px rgb(0 0 0 / 6%), 0 30px 30px rgb(0 0 0 / 7%),
			0 70px 65px rgb(0 0 0 / 9%);
		z-index: 10;
	}
`;

const Block = styled.div`
	margin-bottom: 24px;
`;

export default function Loing() {
	const textRef = useRef<Text>(null);
	const passwordRef = useRef<Password>(null);
	const wrapperRef = useRef(null);
	const [_login, loading] = useLogin();

	const login = () => {
		const account = textRef.current?.getText();
		const password = passwordRef.current?.getText();
		_login({
			account,
			password,
		});
	};

	return (
		<Wrapper ref={wrapperRef}>
			<div className="-panel">
				<h2>登入 104 HR Max API</h2>
				<Block>
					<Text ref={textRef} className="lg" placeholder="帳號" onEnter={() => login()} />
				</Block>
				<Block>
					<Password ref={passwordRef} className="lg" placeholder="密碼" onEnter={() => login()} />
				</Block>

				<Button.Normal theme="primary" className="btn-lg btn-block" loading={loading} onClick={() => login()}>
					登入
				</Button.Normal>
			</div>
		</Wrapper>
	);
}
